document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.poemia-shop-the-look__hotspot-trigger');
  const hotspot = event.target.closest('.poemia-shop-the-look__hotspot');

  if (trigger && hotspot) {
    const isActive = hotspot.classList.toggle('is-active');
    trigger.setAttribute('aria-expanded', String(isActive));
    return;
  }

  document.querySelectorAll('.poemia-shop-the-look__hotspot.is-active').forEach((activeHotspot) => {
    if (!activeHotspot.contains(event.target)) {
      activeHotspot.classList.remove('is-active');
      activeHotspot.querySelector('.poemia-shop-the-look__hotspot-trigger')?.setAttribute('aria-expanded', 'false');
    }
  });
});